import { Box, Skeleton } from '@mui/material';
import { ResponseCard } from './public-response-item';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ResponsePlaceholder = function ResponsePlaceholder() {
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      display: 'flex'
    },
    "data-element": "Box",
    "data-component": "ResponsePlaceholder",
    "data-source-file": "response-placeholder.tsx",
    children: /*#__PURE__*/_jsxs(ResponseCard, {
      sx: {
        mt: 1,
        mb: 2,
        p: 3,
        display: 'flex',
        flexDirection: 'row'
      },
      "data-element": "ResponseCard",
      "data-component": "ResponsePlaceholder",
      "data-source-file": "response-placeholder.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        variant: "circular",
        width: 53,
        height: 48,
        "data-element": "Skeleton",
        "data-component": "ResponsePlaceholder",
        "data-source-file": "response-placeholder.tsx"
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: 1,
          ml: 2
        },
        "data-element": "Box",
        "data-source-file": "response-placeholder.tsx",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          variant: "rectangular",
          height: 16,
          width: "25%",
          "data-element": "Skeleton",
          "data-source-file": "response-placeholder.tsx"
        }), /*#__PURE__*/_jsx(Skeleton, {
          variant: "rectangular",
          height: 16,
          width: "50%",
          "data-element": "Skeleton",
          "data-source-file": "response-placeholder.tsx"
        }), /*#__PURE__*/_jsx(Skeleton, {
          variant: "rectangular",
          height: 16,
          width: "50%",
          "data-element": "Skeleton",
          "data-source-file": "response-placeholder.tsx"
        }), /*#__PURE__*/_jsx(Skeleton, {
          variant: "rectangular",
          height: 16,
          width: "15%",
          "data-element": "Skeleton",
          "data-source-file": "response-placeholder.tsx"
        })]
      })]
    })
  });
};

export default ResponsePlaceholder;